// extracted by mini-css-extract-plugin
module.exports = {"item":"ImageSelectTiny_item__3MX1K"};